import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import ViewHOC from '../hoc/view';

const propTypes = {
	children: PropTypes.array,
	className: PropTypes.string
};

const SwitchControlSingleDecorator = props => (
	<div className={cn(
		'switch-control switch-control-single', props.className && props.className)
	}>{ props.children }</div>
);

SwitchControlSingleDecorator.propTypes = propTypes;
export default ViewHOC(SwitchControlSingleDecorator);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/switch-control/single/main.js